import { defineCopy } from '@/i18n'

// Form errors and status are stored as codes in Contact.vue and looked up here,
// so a message already on screen follows a language switch.
export default defineCopy('contact', {
  id: {
    title: 'Kontak Kami',
    crumb: 'Kontak',
    info: {
      badge: 'Hubungi Kami',
      title: { pre: 'Kami Siap ', hl: 'Membantu', post: '' },
      desc: 'Hubungi kami untuk mendiskusikan bagaimana kami dapat membantu bisnis Anda tumbuh dan sukses dalam dunia digital.',
      address: 'Alamat',
      phone: 'Telepon',
      email: 'Email',
    },
    form: {
      title: 'Kirim Pesan',
      intro: 'Isi formulir di bawah dan kami akan segera merespon.',
      name: { label: 'Nama', placeholder: 'Nama Anda' },
      email: { label: 'Email', placeholder: 'Email Anda' },
      subject: { label: 'Subjek', placeholder: 'Subjek Pesan' },
      message: { label: 'Pesan', placeholder: 'Pesan Anda' },
      sending: 'Mengirim...',
      submit: 'Kirim Pesan',
    },
    errors: {
      name: { required: 'Nama wajib diisi.', tooShort: 'Nama minimal 2 karakter.' },
      email: { required: 'Email wajib diisi.', invalid: 'Format email tidak valid.' },
      subject: { required: 'Subjek wajib diisi.', tooShort: 'Subjek minimal 3 karakter.' },
      message: { required: 'Pesan wajib diisi.', tooShort: 'Pesan minimal 10 karakter.' },
    },
    status: {
      sent: 'Pesan berhasil dikirim!',
      tokenFailed: 'Gagal mendapatkan token. Silakan coba lagi.',
      tooMany: 'Terlalu banyak permintaan. Coba lagi dalam 1 menit.',
      sendFailed: 'Gagal mengirim email. Silakan coba lagi nanti.',
      failed: 'Terjadi kesalahan. Silakan coba lagi.',
      network: 'Gagal terhubung ke server. Silakan coba lagi nanti.',
    },
  },
  en: {
    title: 'Contact Us',
    crumb: 'Contact',
    info: {
      badge: 'Get in Touch',
      title: { pre: "We're Ready to ", hl: 'Help', post: '' },
      desc: 'Contact us to discuss how we can help your business grow and succeed in the digital world.',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
    },
    form: {
      title: 'Send a Message',
      intro: "Fill in the form below and we'll get back to you soon.",
      name: { label: 'Name', placeholder: 'Your name' },
      email: { label: 'Email', placeholder: 'Your email' },
      subject: { label: 'Subject', placeholder: 'Message subject' },
      message: { label: 'Message', placeholder: 'Your message' },
      sending: 'Sending...',
      submit: 'Send Message',
    },
    errors: {
      name: { required: 'Name is required.', tooShort: 'Name must be at least 2 characters.' },
      email: { required: 'Email is required.', invalid: 'Please enter a valid email address.' },
      subject: { required: 'Subject is required.', tooShort: 'Subject must be at least 3 characters.' },
      message: { required: 'Message is required.', tooShort: 'Message must be at least 10 characters.' },
    },
    status: {
      sent: 'Message sent!',
      tokenFailed: 'Could not start a secure session. Please try again.',
      tooMany: 'Too many requests. Please try again in a minute.',
      sendFailed: 'Could not send your message. Please try again later.',
      failed: 'Something went wrong. Please try again.',
      network: 'Could not reach the server. Please try again later.',
    },
  },
})
